import React, { useMemo } from 'react';
import './Page.css';
import { useTranslation } from 'react-i18next';
import { GUIDES } from '../../content/guides';

function GuideArticle({ slug, onBack, onPlay, basePath = '' }) {
  const { t } = useTranslation();

  const article = useMemo(() => GUIDES.find((g) => g.slug === slug) || null, [slug]);
  const prefix = basePath?.endsWith('/') ? basePath.slice(0, -1) : basePath;

  return (
    <div className="page-container">
      <h1>{article ? t(article.titleKey) : t('guide_not_found_title')}</h1>

      {article ? (
        <>
          {article.paragraphs.map((k) => (
            <p key={k}>{t(k)}</p>
          ))}
        </>
      ) : (
        <p>{t('guide_not_found_body')}</p>
      )}

      <div className="page-actions-row">
        <a
          className="back-button"
          href={`${prefix}/guides`}
          onClick={(e) => {
            e.preventDefault();
            onBack();
          }}
        >
          {t('back_to_guides')}
        </a>
        <a
          className="back-button"
          href={`${prefix}/game`}
          onClick={(e) => {
            e.preventDefault();
            onPlay();
          }}
        >
          {t('play_button')}
        </a>
      </div>
    </div>
  );
}

export default GuideArticle;
